module.exports = "./img/338d879fb7f959b9ebf8eedb12d02368.png";